var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D2D2D",
    fillRule: "evenodd",
    d: "m10.47 12-6.25 6.26c-.34.34-.28.95.14 1.38.43.42 1.04.48 1.38.14L12 13.53l6.26 6.25c.34.34.95.28 1.38-.14.42-.43.48-1.04.14-1.38L13.53 12l6.25-6.26c.34-.34.28-.95-.14-1.38-.43-.42-1.04-.48-1.38-.14L12 10.47 5.74 4.22c-.34-.34-.95-.28-1.38.14-.42.43-.48 1.04-.14 1.38L10.47 12Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f0f31094762c2bfdc2ddc25c214b5f36.svg";
export { ForwardRef as ReactComponent };